import { Component, Input, OnInit } from '@angular/core'
import { ComponentWithCopy } from '../../intefaces/interfaces'
import { NgClass } from '@angular/common'
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large'
import { BodyLarge } from '../../components/typography/body-large/body-large'
import { AnimateOnScroll } from 'primeng/animateonscroll'
@Component({
	selector: 'app-feature-with-centered-image',
	imports: [NgClass, HeadlineLarge, BodyLarge, AnimateOnScroll],
	templateUrl: './feature-with-centered-image.html',
	styleUrl: './feature-with-centered-image.css',
})
export class FeatureWithCenteredImage implements OnInit {
	@Input() content!: ComponentWithCopy

	leftList!: any[]
	rightList!: any[]

	ngOnInit(): void {
    const arr = this.content.copy
		if (arr.length > 0) {
			this.leftList = arr.slice(0, 2)
			this.rightList = arr.length > 2 ? arr.slice(-2) : arr.slice(0); // Avoid duplication if array has ≤ 2 items
		}
	}
}
